import React, { useState, useEffect } from "react";
import {
  Instagram,
  Linkedin,
  Youtube,
} from "lucide-react";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import MenuIcon from "@mui/icons-material/Menu";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { IconButton } from "@mui/material";
import { useNavigate, Link, useLocation } from "react-router-dom";
// import "./Homepage.css";
// import "./HomepageMobile.css";
import "./Header.css";

const menuItems = {
  "What We Offer": [
    { name: "Integration Solutions", path: "/Migrating-ERPSolutions" },
    { name: "Enterprise Integration Solutions", path: "/ERP-Solutions" },
    {
      name: "Cloud-Native Excellence: CI/CD, DevOps & Automation",
      path: "/Devops-Services",
    },
    { name: "Application Management & Support", path: "/AMS-Services" },
    { name: "ERP Consulting & End-to-End Solutions", path: "/ERP-Consulting" },
  ],
  Knowledge: [
    { name: "Success Stories", path: "/blogs" },
    { name: "White Papers", path: "/White-Papers" },
  ],
  "Our Partners": [
    { name: "Service Now", path: "/Service-Now" },
    { name: "Google Cloud", path: "/Google-Cloud" },
    { name: "Salesforce", path: "/Salesforce" },
    { name: "SAP Labs", path: "/SAP-Labs" },
  ],
  About: [
    { name: "About Us", path: "/AboutUs" },
    { name: "Careers", path: "/careers" },
  ],
  Contact: [{ name: "Contact Us", path: "/Get-In-Touch" }],
};

const Header = ({ hideScheduleButton = false, hideContact = false }) => {
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
  const location = useLocation();

  // Hide Schedule a Call button if we're on the contact page
  const shouldHideButton = hideScheduleButton || location.pathname === "/Get-In-Touch";

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 440);
    };

    const handleResize = () => {
      // Switch to mobile view at 1024px or when the screen is in portrait mode
      setIsMobile(window.innerWidth <= 1024 || (window.innerHeight > window.innerWidth));
    };

    // Initial check
    handleResize();

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  // useEffect(() => {
  //   if (isMobile) {
  //     import("./HomepageMobile.css");
  //     document.body.style.overflowX = "hidden";
  //   } else {
  //     import("./Homepage.css");
  //     document.body.style.overflowX = "auto";
  //   }
  // }, [isMobile]);

  const handleToggleMenu = (menu) => {
    setOpenDropdown(openDropdown === menu ? null : menu);
  };

  const handleMouseEnter = (menu) => {
    setOpenDropdown(menu);
  };

  const handleMouseLeave = () => {
    setOpenDropdown(null);
  };

  return (
    <header className="main-header">
      <div className="header-container">
        <Link to="/" className="logo-link">
          <img
            src="/images/CYNTRALABS Logo.png"
            alt="CyntraLabs Logo"
            className="header-logo"
          />
        </Link>

        {!isMobile && (
          <nav className="header-nav">
            <div className="nav-links">
              {Object.entries(menuItems).map(([menu, links]) => {
                // Skip rendering the Contact menu if hideContact is true
                if (hideContact && menu === "Contact") return null;
                return (
                  <div
                    key={menu}
                    className="dropdown-container"
                    onMouseEnter={() => handleMouseEnter(menu)}
                    onMouseLeave={handleMouseLeave}
                  >
                    <button
                      className="nav-link"
                      onClick={() => handleToggleMenu(menu)}
                    >
                      {menu}
                      <span
                        className={`dropdown-icon ${openDropdown === menu ? "rotate" : ""}`}
                      >
                        <KeyboardArrowDownIcon />
                      </span>
                    </button>
                    {openDropdown === menu && (
                      <div className="dropdown-menu">
                        <ul>
                          {links.map((item, index) => (
                            <li key={index}>
                              {typeof item.path === "string" ? (
                                <Link
                                  to={item.path}
                                  className="dropdown-button"
                                  onClick={() => setOpenDropdown(null)}
                                >
                                  {item.name}
                                </Link>
                              ) : (
                                <button
                                  className="dropdown-button"
                                  onClick={() => {
                                    item.path();
                                    setOpenDropdown(null);
                                  }}
                                >
                                  {item.name}
                                </button>
                              )}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </nav>
        )}

        {!shouldHideButton && (
        <div className="nav-buttons">
          <Link to="/Get-In-Touch" className="header-cta-button">
            Schedule a Call
          </Link>
        </div>
        )}

        {isMobile && (
          <IconButton onClick={toggleDrawer(true)} className="menu-button">
            <MenuIcon fontSize="large" />
          </IconButton>
        )}

        <SwipeableDrawer
          anchor="right"
          open={drawerOpen}
          onClose={toggleDrawer(false)}
          onOpen={toggleDrawer(true)}
        >
          <div className="mobile-nav-v2">
            {Object.entries(menuItems).map(([menu, links]) => {
              // Skip rendering the Contact menu if hideContact is true
              if (hideContact && menu === "Contact") return null;
              return (
                <div key={menu}>
                  <button
                    className="mobile-nav-button-v2"
                    onClick={() => handleToggleMenu(menu)}
                  >
                    {menu}
                    <span
                      className={`dropdown-icon-v2 ${
                        openDropdown === menu ? "rotate-v2" : ""
                      }`}
                    >
                      <KeyboardArrowDownIcon />
                    </span>
                  </button>
                  {openDropdown === menu && (
                    <div className="mobile-dropdown-v2">
                      <ul>
                        {links.map((item, index) => (
                          <li key={index}>
                            {typeof item.path === "string" ? (
                              <Link
                                to={item.path}
                                className="dropdown-button-v2"
                                onClick={() => {
                                  setOpenDropdown(null);
                                  setDrawerOpen(false);
                                }}
                              >
                                {item.name}
                              </Link>
                            ) : (
                              <button
                                className="dropdown-button-v2"
                                onClick={() => {
                                  item.path();
                                  setOpenDropdown(null);
                                  setDrawerOpen(false);
                                }}
                              >
                                {item.name}
                              </button>
                            )}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </SwipeableDrawer>
      </div>
    </header>
  );
};

export default Header;
